import { DropDownButton, DropdownItem, Icon } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';

interface Action {
    text: React.ReactNode;
    onClick?: () => void;
    icon: IconName;
    key: string;
    dataTestId?: string;
}

interface PaymentsTablesActionsMenuProps {
    actions: Action[];
}

export const PaymentsTablesActionsMenu = ({ actions }: PaymentsTablesActionsMenuProps) => (
    <DropDownButton icon={IconName.More} size="small" variant="ghost">
        {actions.map(({ text, onClick, icon, key, dataTestId }) => (
            <DropdownItem
                label={text}
                onClick={onClick}
                leftDetail={<Icon value={icon} />}
                key={key}
                {...(dataTestId && { 'data-test-id': dataTestId })}
            />
        ))}
    </DropDownButton>
);
